module.exports = __webpack_public_path__ + "static/media/IMG-20211031-WA0019.38a16f84.jpg";